// extracted by mini-css-extract-plugin
export var item = "Item-module--item--2cwQu";
export var item__text__subtitle = "Item-module--item__text__subtitle--QvPyR";
export var iconWrap = "Item-module--iconWrap--3Jhr5";
export var iconWrap__inner = "Item-module--iconWrap__inner--10ftG";
export var icon = "Item-module--icon--58ZjP";
export var animeIcon = "Item-module--animeIcon--2VrmV";
export var item__text = "Item-module--item__text--2nLSh";
export var item__text__title = "Item-module--item__text__title--3IYXL";